(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-c300-lite-live-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-xc-live-product]').forEach((root) => {
    const variantData = root.querySelector('[data-xc-variant-data]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const optionGroups = Array.from(root.querySelectorAll('[data-option-position]'));
    const getOptionPosition = (group) => Math.max(0, Number(group?.dataset.optionPosition || 1) - 1);
    const getSelectedOptions = () => {
      const selected = [];
      optionGroups.forEach((group) => {
        selected[getOptionPosition(group)] = group.querySelector('input:checked')?.value || '';
      });
      return selected;
    };
    const variantInput = root.querySelector('[data-xc-variant-id]');
    const price = root.querySelector('[data-xc-price]');
    const discountedPrice = root.querySelector('[data-xc-discounted-price]');
    const productHeading = root.querySelector('[data-xc-product-heading]');
    const compareRow = root.querySelector('[data-xc-compare-row]');
    const compare = root.querySelector('[data-xc-compare]');
    const saving = root.querySelector('[data-xc-saving]');
    const mainImage = root.querySelector('.xc-live-product__main-media img');
    const mainMedia = root.querySelector('[data-xc-main-media]');
    const galleryThumbs = Array.from(root.querySelectorAll('[data-xc-media-thumb]'));
    const variantThumb = root.querySelector('[data-xc-variant-thumb]');
    const previousButton = root.querySelector('[data-xc-gallery-previous]');
    const nextButton = root.querySelector('[data-xc-gallery-next]');
    const galleryCounter = root.querySelector('[data-xc-gallery-counter]');
    const buyButton = root.querySelector('[data-xc-buy]');
    const mobileSticky = root.querySelector('[data-xc-mobile-buy]');
    const mobileSubmit = root.querySelector('[data-xc-mobile-submit]');
    const mobileStickyPrice = root.querySelector('[data-xc-mobile-sticky-price]');
    const mobileStickySelection = root.querySelector('[data-xc-mobile-sticky-selection]');
    const skuDrawer = root.querySelector('[data-xc-mobile-sku-drawer]');
    const skuDrawerOptions = root.querySelector('[data-xc-mobile-sku-options]');
    const skuDrawerPrice = root.querySelector('[data-xc-mobile-sku-price]');
    const skuDrawerSelection = root.querySelector('[data-xc-mobile-sku-selection]');
    const skuDrawerBuy = root.querySelector('[data-xc-mobile-sku-buy]');
    const form = root.querySelector('[data-xc-checkout-form]');
    const error = root.querySelector('[data-xc-error]');
    const whatsappLinks = Array.from(root.querySelectorAll('[data-xc-whatsapp-link]'));
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const productTitle = root.dataset.productTitle || '';
    const productHandle = root.dataset.productHandle || '';
    const campaignState = window.XC_CAMPAIGN_STATE || {};
    const campaignPriceLabel = () => campaignState.priceLabel?.(productHandle) || '秋季特惠到手價';
    const campaignToastLabel = () => campaignState.toastLabel?.(productHandle) || '🎉 秋季特惠 · 5% 優惠已自動生效';
    const isC100StyleProduct = productHandle === 'c100' || productHandle === 'c300-pro' || productHandle === 'c300-lite' || productHandle === 'c300i' || productHandle === 'c500i' || productHandle === 'b300-b300pro' || productHandle === 's300l';
    const isSingleVariantProduct = variants.length === 1;
    const stockNotice = root.querySelector('[data-xc-stock-notice]');
    const promo = root.querySelector('.xc-live-product__promo');
    const stockSensitiveItems = Array.from(root.querySelectorAll('[data-xc-stock-sensitive]'));
    const discountBadge = root.querySelector('[data-xc-discount-badge]');
    const c100PriceBlock = root.querySelector('[data-xc-c100-price-block]');
    const c100PriceState = root.querySelector('[data-xc-c100-price-state]');
    const c100PriceStateText = root.querySelector('[data-xc-c100-price-state-text]');
    const c100Toast = root.querySelector('[data-xc-c100-toast]');
    let hasUserSelectedVariant = false;
    let activeVariant = null;
    let c100OfferStarted = false;
    let c100AnimationToken = 0;
    let skuDrawerInvoker = null;

    const commitVariantInput = (variant) => {
      if (!variantInput || !variant?.id) return;
      const variantId = String(variant.id);
      variantInput.value = variantId;
      variantInput.defaultValue = variantId;
      variantInput.setAttribute('value', variantId);
    };

    const getConciseHeading = (variant = null) => {
      switch (productHandle) {
        case 'c300i':
          return 'C300i 二代｜AI 智能人體工學椅';
        case 'c100':
          return '西昊 SIHOO C100 人體工學椅';
        case 'c300-pro':
          return '西昊 SIHOO C300 Pro 人體工學椅';
        case 'b300-b300pro': {
          const isPro = (variant?.title || '').includes('尊享款') || (variant?.title || '').includes('B300Pro');
          return `西昊 SIHOO ${isPro ? 'B300 Pro' : 'B300'} 人體工學椅`;
        }
        case 'c300-lite':
          return '西昊 SIHOO C300 Lite 人體工學椅';
        case 'c500i':
          return '西昊 SIHOO C500i 二代 人體工學椅';
        case 's300l':
          return '西昊 SIHOO S300L 人體工學椅';
        default:
          return '';
      }
    };

    let activeGalleryIndex = 0;

    const pushCommerceEvent = (eventName, variant, buttonPosition = '') => {
      const eventParameters = {
        product_handle: productHandle,
        product_title: productTitle,
        variant_id: variant?.id ? String(variant.id) : '',
        variant_title: variant?.title || '',
        price: variant?.price || '',
        availability: variant?.available === false ? 'out_of_stock' : 'in_stock',
        button_position: buttonPosition,
        page_path: window.location.pathname
      };

      if (typeof window.xcTrackEvent === 'function') {
        window.xcTrackEvent(eventName, eventParameters);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...eventParameters });
    };

    const syncDiscountedPrice = (variant) => {
      if (!discountedPrice || !variant?.price) return;
      const base = Number(String(variant.price).replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(base)) return;
      discountedPrice.textContent = `HK$${(base * 0.95).toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const numericPrice = (variant) => Number(String(variant?.price || '').replace(/[^0-9.]/g, ''));
    const displayPrice = (variant) => {
      if (!variant?.price) return '';
      const raw = String(variant.price);
      const amount = numericPrice(variant);
      if (!isC100StyleProduct || !Number.isFinite(amount)) return raw;
      const prefix = raw.match(/^[^0-9]*/)?.[0] || '';
      return `${prefix}${(amount * 0.95).toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };
    const c100Money = (variant, amount) => {
      const raw = String(variant?.price || 'HK$');
      const prefix = raw.match(/^[^0-9]*/)?.[0] || 'HK$';
      return `${prefix}${Number(amount).toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };
    const syncC100Saving = (variant, displayedAmount) => {
      if (!saving || !variant?.compareAt) return;
      const compareValue = Number(String(variant.compareAt).replace(/[^0-9.]/g, ''));
      if (!Number.isFinite(compareValue) || !Number.isFinite(displayedAmount)) return;
      const totalSaving = Math.max(0, Math.round((compareValue - displayedAmount) * 100) / 100);
      saving.textContent = `${saving.dataset.savingLabel} ${c100Money(variant, totalSaving)}`;
      saving.style.removeProperty('visibility');
    };
    const syncC100PriceState = (variant, isFinal = c100OfferStarted) => {
      if (!isC100StyleProduct || !c100PriceState || !variant) return;
      c100PriceState.classList.toggle('is-final', isFinal);
      if (c100PriceStateText) c100PriceStateText.textContent = isFinal ? campaignPriceLabel() : '日常售價';
    };
    const showC100Toast = () => {
      if (!c100Toast) return;
      const toastText = c100Toast.querySelector('span:last-child');
      if (toastText) toastText.textContent = campaignToastLabel().replace(/^🎉\s*/, '');
      c100Toast.hidden = false;
      c100Toast.classList.remove('is-visible');
      void c100Toast.offsetWidth;
      c100Toast.classList.add('is-visible');
      window.setTimeout(() => {
        c100Toast.classList.remove('is-visible');
        c100Toast.hidden = true;
      }, 3000);
    };
    const runC100OfferAnimation = (variant = activeVariant) => {
      if (!isC100StyleProduct || c100OfferStarted || !variant || !price) return;
      const start = numericPrice(variant);
      const end = start * 0.95;
      if (!Number.isFinite(start) || !Number.isFinite(end)) return;
      c100OfferStarted = true;
      const token = ++c100AnimationToken;
      showC100Toast();
      syncC100PriceState(variant, false);
      if (saving) saving.style.visibility = 'hidden';
      if (prefersReducedMotion) {
        price.textContent = displayPrice(variant);
        syncC100Saving(variant, end);
        syncC100PriceState(variant, true);
        return;
      }
      const startedAt = performance.now();
      const duration = 3000;
      const tick = (now) => {
        if (token !== c100AnimationToken) return;
        const progress = Math.min(1, (now - startedAt) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        price.textContent = c100Money(variant, start + (end - start) * eased);
        if (progress < 1) {
          window.requestAnimationFrame(tick);
          return;
        }
        price.textContent = displayPrice(variant);
        syncC100Saving(variant, end);
        syncC100PriceState(variant, true);
      };
      window.requestAnimationFrame(tick);
    };
    const scheduleC100OfferAnimation = () => {
      if (!isC100StyleProduct || !c100PriceBlock) return;
      const isMobile = window.matchMedia('(max-width: 820px)').matches;
      if (!isMobile) {
        window.setTimeout(() => runC100OfferAnimation(activeVariant), 120);
        return;
      }
      let scrollListener;
      const removeScrollListener = () => {
        if (!scrollListener) return;
        window.removeEventListener('scroll', scrollListener);
        scrollListener = null;
      };
      const runAfterMobileScroll = () => {
        if (window.scrollY < 96) return;
        const rect = c100PriceBlock.getBoundingClientRect();
        if (productHandle === 'c100') {
          const priceTop = rect.top + window.scrollY;
          if (window.scrollY + (window.innerHeight * 0.82) < priceTop) return;
          removeScrollListener();
          runC100OfferAnimation(activeVariant);
          return;
        }
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
        removeScrollListener();
        runC100OfferAnimation(activeVariant);
      };
      if (!('IntersectionObserver' in window)) {
        scrollListener = runAfterMobileScroll;
        window.addEventListener('scroll', scrollListener, { passive: true });
        runAfterMobileScroll();
        return;
      }
      const priceObserver = new IntersectionObserver(([entry], observer) => {
        if (!entry.isIntersecting || window.scrollY < 96) return;
        observer.disconnect();
        runAfterMobileScroll();
      }, { threshold: 0.18, rootMargin: '0px 0px -12% 0px' });
      priceObserver.observe(c100PriceBlock);
      scrollListener = runAfterMobileScroll;
      window.addEventListener('scroll', scrollListener, { passive: true });
      runAfterMobileScroll();
    };
    const lowestAvailableVariant = () => variants
      .filter((variant) => variant.available !== false)
      .sort((left, right) => numericPrice(left) - numericPrice(right))[0] || variants[0] || null;
    const syncInputsToVariant = (variant) => {
      if (!variant) return;
      optionGroups.forEach((group) => {
        const optionPosition = getOptionPosition(group);
        const input = Array.from(group.querySelectorAll('input')).find((candidate) => candidate.value === variant.options[optionPosition]);
        if (input) input.checked = true;
      });
    };
    const selectedLabel = (variant) => {
      if (!variant) return '未選擇規格';
      if (productHandle === 'c100') {
        const color = getSelectedOptions()[0] || variant.options?.[0] || '目前顏色';
        return `已選：${color} · 含腳踏`;
      }
      const label = getSelectedOptions().filter(Boolean).join(' / ');
      return label ? `已選：${label}` : `已選：${variant.title || '目前配置'}`;
    };
    const hasCompleteUserSelection = () => {
      if (isSingleVariantProduct) return true;
      return optionGroups.length > 0 && optionGroups.every((group) => Boolean(group.querySelector('input:checked')?.value));
    };
    const syncMobileSticky = (variant = activeVariant) => {
      if (!mobileStickyPrice || !mobileStickySelection || !variant) return;
      const purchaseReady = hasCompleteUserSelection();
      mobileStickyPrice.textContent = `${displayPrice(variant)}${hasUserSelectedVariant ? '' : ' 起'}`;
      mobileStickySelection.textContent = hasUserSelectedVariant ? selectedLabel(variant) : '未選擇規格';
      if (mobileSubmit) {
        mobileStickyPrice.textContent = `${displayPrice(variant)}${purchaseReady ? '' : ' 起'}`;
        mobileStickySelection.textContent = purchaseReady ? selectedLabel(variant) : (hasUserSelectedVariant ? '請完成選擇' : '未選擇規格');
        mobileSubmit.textContent = variant.available === false ? '暫時缺貨' : (purchaseReady ? '立即結賬' : '立即購買');
        mobileSubmit.disabled = variant.available === false;
      }
    };
    const setupC100StickyVisibility = () => {
      if (productHandle !== 'c100' || !mobileSticky || !buyButton) return;
      const syncVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const rect = buyButton.getBoundingClientRect();
        const primaryVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        const shouldShow = isMobile && window.scrollY > 96 && !primaryVisible;
        mobileSticky.classList.toggle('is-visible', shouldShow);
        mobileSticky.setAttribute('aria-hidden', String(!shouldShow));
      };
      window.addEventListener('scroll', syncVisibility, { passive: true });
      window.addEventListener('resize', syncVisibility, { passive: true });
      syncVisibility();
    };
    const syncDrawerSummary = (variant = activeVariant) => {
      if (!skuDrawerPrice || !skuDrawerSelection || !variant) return;
      const purchaseReady = hasCompleteUserSelection();
      skuDrawerPrice.textContent = displayPrice(variant);
      skuDrawerSelection.textContent = purchaseReady ? selectedLabel(variant) : (hasUserSelectedVariant ? '請完成選擇' : '請選擇你的配置');
      if (skuDrawerBuy) skuDrawerBuy.disabled = !purchaseReady || variant.available === false;
    };

    const syncStockState = (variant) => {
      const isOutOfStock = !variant || variant.available === false;
      root.classList.toggle('is-sold-out', isOutOfStock);
      root.dataset.xcAvailability = isOutOfStock ? 'out_of_stock' : 'in_stock';
      if (stockNotice) stockNotice.hidden = !isOutOfStock;
      if (promo) {
        promo.hidden = isOutOfStock;
        if (isOutOfStock) promo.style.setProperty('display', 'none', 'important');
        else promo.style.removeProperty('display');
      }
      stockSensitiveItems.forEach((item) => {
        item.hidden = isOutOfStock;
        if (isOutOfStock) item.style.setProperty('display', 'none', 'important');
        else item.style.removeProperty('display');
      });
      if (isOutOfStock && discountBadge) discountBadge.hidden = true;
    };

    const updateWhatsappLinks = (variant) => {
      if (!variant) return;
      const friendlyTitle = productHandle === 'b300-b300pro' ? (variant.title || '').replace('尊享款', 'B300 Pro').replace('常規款', 'B300') : (variant.title || '');
      const isOutOfStock = variant.available === false;
      const message = isOutOfStock
        ? '你好，我想查詢 ' + productTitle + ' 的產品與可選配置。\n目前選擇：' + friendlyTitle + '\n請協助確認可選配置與購買安排，謝謝！'
        : isC100StyleProduct
          ? '你好，我想了解 ' + productTitle + '。\n目前選擇：' + friendlyTitle + '\n網站售價：' + variant.price + '\n' + campaignPriceLabel() + '：約 ' + displayPrice(variant) + '\n請問這個配置的最終優惠及送貨安排？'
          : '你好，我想了解 ' + productTitle + '。\n目前選擇：' + friendlyTitle + '\n目前售價：' + variant.price + '\n請問這個配置的版本、95 折後價格及送貨安排？';
      whatsappLinks.forEach((link) => {
        link.href = `https://wa.me/8613005471130?text=${encodeURIComponent(message)}`;
        link.dataset.xcVariantId = String(variant.id);
        link.dataset.xcVariantTitle = variant.title || '';
        link.dataset.xcPrice = variant.price || '';
        link.dataset.xcAvailability = isOutOfStock ? 'out_of_stock' : 'in_stock';
      });
    };

    const selectMedia = (index, moveThumbnail = false, updateImage = true) => {
      if (!galleryThumbs.length) return;
      activeGalleryIndex = Math.max(0, Math.min(index, galleryThumbs.length - 1));
      const selectedThumb = galleryThumbs[activeGalleryIndex];
      if (updateImage && mainImage && selectedThumb.dataset.imageUrl) {
        if (selectedThumb.dataset.imageSrcset) {
          mainImage.sizes = selectedThumb.dataset.imageSizes || '(min-width: 990px) 56vw, 100vw';
          mainImage.srcset = selectedThumb.dataset.imageSrcset;
        } else {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
        mainImage.src = selectedThumb.dataset.imageUrl;
        mainImage.alt = selectedThumb.dataset.imageAlt || mainImage.alt;
      }
      galleryThumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-current', String(thumbIndex === activeGalleryIndex));
      });
      if (galleryCounter) galleryCounter.textContent = `${activeGalleryIndex + 1} / ${galleryThumbs.length}`;
      if (previousButton) previousButton.disabled = activeGalleryIndex === 0;
      if (nextButton) nextButton.disabled = activeGalleryIndex === galleryThumbs.length - 1;
      if (moveThumbnail) selectedThumb.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    };

    const updateVariantThumb = (variant) => {
      if (!variantThumb || !variant.imageUrl) return;
      variantThumb.dataset.mediaId = variant.mediaId || '';
      variantThumb.dataset.imageUrl = variant.imageUrl;
      variantThumb.dataset.imageSrcset = variant.imageSrcset || '';
      variantThumb.dataset.imageSizes = '(min-width: 990px) 56vw, 100vw';
      variantThumb.dataset.imageAlt = variant.imageAlt || '';
      const thumbImage = variantThumb.querySelector('img');
      if (thumbImage) {
        thumbImage.src = variant.thumbUrl || variant.imageUrl;
        thumbImage.removeAttribute('srcset');
        thumbImage.alt = variant.imageAlt || thumbImage.alt;
      }
    };

    const syncOptionAvailability = () => {
      const selectedOptions = getSelectedOptions();
      const accessoryGroup = optionGroups.find((group) => /配件|脚踏|腳踏/.test(group.querySelector('legend')?.textContent || ''));
      const accessoryPosition = accessoryGroup ? getOptionPosition(accessoryGroup) : -1;

      optionGroups.forEach((group) => {
        const optionPosition = getOptionPosition(group);
        group.querySelectorAll('[data-xc-option-value]').forEach((input) => {
          let available = variants.some((item) => item.available && item.options[optionPosition] === input.value);

          if (optionPosition === accessoryPosition) {
            available = variants.some((item) => {
              if (!item.available || item.options[optionPosition] !== input.value) return false;
              return item.options.every((value, index) => index === optionPosition || !selectedOptions[index] || value === selectedOptions[index]);
            });
          }

          input.disabled = !available;
          const label = input.nextElementSibling;
          if (label) {
            label.classList.toggle('is-unavailable', !available);
            label.setAttribute('aria-disabled', String(!available));
            const unavailableLabel = label.querySelector('[data-xc-unavailable-label]');
            if (unavailableLabel) unavailableLabel.hidden = available;
          }
        });
      });
    };

    const updateVariant = (changedInput = null) => {
      const selectedOptions = getSelectedOptions();
      let variant = variants.find((item) => item.options.every((value, index) => !selectedOptions[index] || value === selectedOptions[index]));
      if (!variant && changedInput) {
        const changedGroup = changedInput.closest('[data-option-position]');
        const changedPosition = Number(changedGroup?.dataset.optionPosition || 0) - 1;
        const candidates = variants
          .filter((item) => item.options[changedPosition] === changedInput.value)
          .sort((left, right) => {
            const leftScore = left.options.reduce((score, value, index) => score + (value === selectedOptions[index] ? 1 : 0), 0);
            const rightScore = right.options.reduce((score, value, index) => score + (value === selectedOptions[index] ? 1 : 0), 0);
            return rightScore - leftScore;
          });
        variant = candidates.find((item) => item.available) || candidates[0];
        if (variant) {
          optionGroups.forEach((group) => {
            const optionPosition = getOptionPosition(group);
            const input = Array.from(group.querySelectorAll('input')).find((candidate) => candidate.value === variant.options[optionPosition]);
            if (input) input.checked = true;
          });
        }
      }
      if (!variant) return;

      if (changedInput) hasUserSelectedVariant = true;
      if (changedInput && isC100StyleProduct && c100OfferStarted) c100AnimationToken += 1;
      activeVariant = variant;

      commitVariantInput(variant);
      if (changedInput) {
        window.requestAnimationFrame(() => {
          if (activeVariant?.id === variant.id) commitVariantInput(variant);
        });
        window.setTimeout(() => {
          if (activeVariant?.id === variant.id) commitVariantInput(variant);
        }, 360);
      }
      if (productHeading) {
        const displayTitle = getConciseHeading(variant);
        if (displayTitle) {
          productHeading.textContent = displayTitle;
          productHeading.setAttribute('title', displayTitle);
        }
      }
      price.textContent = isC100StyleProduct && c100OfferStarted ? displayPrice(variant) : variant.price;
      syncDiscountedPrice(variant);
      compareRow.hidden = !variant.compareAt;
      if (variant.compareAt) {
        compare.textContent = variant.compareAt;
        if (isC100StyleProduct) {
          const shownAmount = c100OfferStarted ? numericPrice(variant) * 0.95 : numericPrice(variant);
          syncC100Saving(variant, shownAmount);
        } else {
          saving.textContent = `${saving.dataset.savingLabel} ${variant.saving}`;
        }
      }
      buyButton.disabled = !variant.available;
      mobileSubmit.disabled = !variant.available;
      buyButton.textContent = variant.available ? buyButton.dataset.buyLabel : buyButton.dataset.soldOutLabel;
      mobileSubmit.textContent = buyButton.textContent;
      updateVariantThumb(variant);
      syncOptionAvailability();
      selectMedia(0, true);
      syncStockState(variant);
      updateWhatsappLinks(variant);
      syncC100PriceState(variant);
      syncMobileSticky(variant);
      syncDrawerSummary(variant);
      renderDrawerOptions?.();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (changedInput) pushCommerceEvent('variant_change', variant, 'pdp_options');
    };

    const renderDrawerOptions = () => {
      if (!skuDrawerOptions) return;
      skuDrawerOptions.replaceChildren();
      optionGroups.forEach((group) => {
        const legend = group.querySelector('legend')?.textContent?.trim() || '規格';
        const drawerGroup = document.createElement('fieldset');
        drawerGroup.className = 'xc-live-product__mobile-sku-group';
        const drawerLegend = document.createElement('legend');
        drawerLegend.textContent = legend;
        const choiceList = document.createElement('div');
        choiceList.className = 'xc-live-product__mobile-sku-choice-list';

        group.querySelectorAll('[data-xc-option-value]').forEach((input) => {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'xc-live-product__mobile-sku-choice';
          choice.textContent = (productHandle === 'b300-b300pro' && input.value === 'B300Pro') ? 'B300 Pro' : input.value;
          choice.disabled = input.disabled;
          choice.classList.toggle('is-selected', hasUserSelectedVariant && input.checked);
          choice.addEventListener('click', () => {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          choiceList.appendChild(choice);
        });

        drawerGroup.append(drawerLegend, choiceList);
        skuDrawerOptions.appendChild(drawerGroup);
      });
    };

    const openSkuDrawer = () => {
      if (!skuDrawer) return;
      skuDrawerInvoker = document.activeElement;
      renderDrawerOptions();
      syncDrawerSummary(activeVariant || lowestAvailableVariant());
      skuDrawer.hidden = false;
      document.documentElement.classList.add('xc-mobile-sku-drawer-open');
      skuDrawer.querySelector('[data-xc-mobile-sku-close]')?.focus({ preventScroll: true });
    };

    const closeSkuDrawer = () => {
      if (!skuDrawer) return;
      skuDrawer.hidden = true;
      document.documentElement.classList.remove('xc-mobile-sku-drawer-open');
      skuDrawerInvoker?.focus({ preventScroll: true });
      skuDrawerInvoker = null;
    };

    [
      ...Array.from(root.querySelectorAll('[data-xc-mobile-sku-close]')),
    ].forEach((closeButton) => closeButton.addEventListener('click', closeSkuDrawer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && skuDrawer && !skuDrawer.hidden) closeSkuDrawer();
    });

    root.querySelectorAll('[data-xc-option-value]').forEach((input) => input.addEventListener('change', () => updateVariant(input)));
    galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectMedia(index));
    });
    previousButton?.addEventListener('click', () => selectMedia(activeGalleryIndex - 1, true));
    nextButton?.addEventListener('click', () => selectMedia(activeGalleryIndex + 1, true));

    let touchStartX = 0;
    let touchStartY = 0;
    mainMedia?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    mainMedia?.addEventListener('touchend', (event) => {
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      if (deltaX < 0) selectMedia(activeGalleryIndex + 1, true);
      if (deltaX > 0) selectMedia(activeGalleryIndex - 1, true);
    }, { passive: true });

    syncOptionAvailability();
    selectMedia(0, false, false);
    const linkedVariantId = new URL(window.location.href).searchParams.get('variant');
    const linkedVariant = variants.find((item) => String(item.id) === String(linkedVariantId) && item.available !== false);
    const initialVariant = linkedVariant || variants.find((item) => String(item.id) === String(variantInput?.value)) || variants[0];
    activeVariant = isC100StyleProduct ? (linkedVariant || lowestAvailableVariant()) : initialVariant;
    if (isC100StyleProduct && activeVariant) {
      commitVariantInput(activeVariant);
      syncInputsToVariant(activeVariant);
      hasUserSelectedVariant = optionGroups.length > 0 && optionGroups.every((group) => Boolean(group.querySelector('input:checked')?.value));
      updateVariant();
    }
    syncStockState(activeVariant || initialVariant);
    updateWhatsappLinks(activeVariant || initialVariant);
    syncDiscountedPrice(activeVariant || initialVariant);
    syncC100PriceState(activeVariant || initialVariant, false);
    syncMobileSticky(activeVariant);
    syncDrawerSummary(activeVariant);
    renderDrawerOptions();
    scheduleC100OfferAnimation();
    setupC100StickyVisibility();

    const submitCheckout = async (selectedVariant, buttonPosition = 'unknown') => {
      if (!selectedVariant || selectedVariant.available === false || !form) return;
      pushCommerceEvent('buy_now_click', selectedVariant, buttonPosition);
      if (error) error.hidden = true;
      if (buyButton) buyButton.disabled = true;
      if (mobileSubmit) mobileSubmit.disabled = true;
      if (skuDrawerBuy) {
        skuDrawerBuy.disabled = true;
        skuDrawerBuy.textContent = '正在前往結賬…';
      }
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const formData = new FormData(form);
        formData.set('id', String(selectedVariant.id));
        formData.set('quantity', '1');
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!response.ok) throw new Error('add_failed');
        window.location.assign(`${rootPath}checkout`);
      } catch (requestError) {
        pushCommerceEvent('checkout_error', selectedVariant, buttonPosition);
        if (error) error.hidden = false;
        if (buyButton) buyButton.disabled = false;
        syncMobileSticky(selectedVariant);
        if (skuDrawerBuy) {
          skuDrawerBuy.disabled = false;
          skuDrawerBuy.textContent = '立即購買';
        }
      }
    };

    mobileSubmit?.addEventListener('click', () => {
      const selectedVariant = activeVariant || lowestAvailableVariant();
      if (!hasCompleteUserSelection()) {
        openSkuDrawer();
        return;
      }
      submitCheckout(selectedVariant, 'mobile_sticky');
    });

    skuDrawerBuy?.addEventListener('click', () => {
      const selectedVariant = variants.find((item) => String(item.id) === String(variantInput?.value)) || activeVariant;
      if (!hasCompleteUserSelection()) return;
      submitCheckout(selectedVariant, 'mobile_sticky_drawer');
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (isC100StyleProduct && !hasCompleteUserSelection()) {
        openSkuDrawer();
        return;
      }
      const selectedVariant = variants.find((item) => String(item.id) === String(variantInput?.value)) || activeVariant;
      if (buyButton?.disabled) return;
      submitCheckout(selectedVariant, event.submitter?.dataset.xcCtaPosition || 'pdp_primary');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-home-office-preview-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var xcFallbackProducts = [
      {
        title: "M57C",
        badge: "Budget Pick",
        body: "預算控制在 2000 以下，又想要透氣坐感時，M57C 是更直接的選擇。",
        budget: "under2000",
        needs: ["breathable", "compact"],
        pills: ["全網透氣", "聯動扶手", "家用友好"],
        price: "查看目前價格",
        url: "/products/m57c",
        image: "https://hk.sihooxchair.com/cdn/shop/files/M57C_black_clean.png?v=1775558402"
      },
      {
        title: "C300二代 PRO",
        badge: "Recommended",
        body: "想要一張主力辦公椅，先看腰背跟隨、座深調節和扶手配置更均衡的 C300二代 PRO。",
        budget: "2000to3000",
        needs: ["lumbar", "office"],
        pills: ["久坐護腰", "座深可調", "5年保固"],
        price: "查看目前價格",
        url: "/products/c300-pro",
        image: "https://sihoooffice.com/cdn/shop/files/1940-1200.webp?v=1705046338&width=760"
      },
      {
        title: "C300二代 PRO 尊享版",
        badge: "Footrest",
        body: "工作、追劇和短休都想兼顧時，腳踏版本更完整，也更適合作為主力座位。",
        budget: "2000to3000",
        needs: ["footrest", "lumbar"],
        pills: ["腳踏短休", "久坐護腰", "5年保固"],
        price: "查看目前價格",
        url: "/products/c300-pro",
        image: "https://cdn.shopify.com/s/files/1/0632/8192/2264/files/1_0642161f-8f30-4702-bb6f-a434f8d70400.webp?v=1776389401"
      },
      {
        title: "C500二代",
        badge: "Flagship",
        body: "重視外觀、坐感和主動護腰支撐時，C500二代會比入門款更一步到位。",
        budget: "over3000",
        needs: ["lumbar", "premium"],
        pills: ["旗艦護腰", "主動支撐", "5年保固"],
        price: "查看目前價格",
        url: "/products/c500",
        image: "https://cdn.shopify.com/s/files/1/0702/0268/7541/files/C500up-black.png?v=1775788645"
      },
      {
        title: "T6",
        badge: "Massage",
        body: "如果按摩是剛需，T6 是更接近放鬆需求的方向，預算也會更高。",
        budget: "over3000",
        needs: ["massage", "premium"],
        pills: ["智能按摩", "高階放鬆", "客服確認"],
        price: "查看目前價格",
        url: "/products/t6",
        image: "https://hk.sihooxchair.com/cdn/shop/files/SKU_02_C500i_AI.jpg?v=1775535370"
      }
    ];

    function xcEscapeHtml(value) {
      return String(value || "").replace(/[&<>"']/g, function(character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      });
    }

    function xcReadChairProducts(root) {
      var script = root.querySelector("[data-xc-products-json]");
      var products = [];
      if (script) {
        try {
          products = JSON.parse(script.textContent || "[]").filter(function(product) {
            return product && product.title && product.image;
          });
        } catch (error) {
          products = [];
        }
      }
      xcFallbackProducts.forEach(function(fallback) {
        var exists = products.some(function(product) {
          return product.url === fallback.url || product.title === fallback.title;
        });
        if (!exists) products.push(fallback);
      });
      return products;
    }

    function xcSelectedNeeds(root) {
      return Array.prototype.slice.call(root.querySelectorAll("[data-xc-need]:checked")).map(function(input) {
        return input.value;
      });
    }

    function xcOtherNeedTags(value) {
      var text = String(value || "").toLowerCase();
      var tags = [];
      if (/腳|foot|休|躺/.test(text)) tags.push("footrest");
      if (/按摩|massage|放鬆/.test(text)) tags.push("massage");
      if (/腰|護腰|lumbar|久坐/.test(text)) tags.push("lumbar");
      if (/熱|透氣|網|breath/.test(text)) tags.push("breathable");
      if (/小|窄|細|compact|空間/.test(text)) tags.push("compact");
      if (/高階|旗艦|質感|premium/.test(text)) tags.push("premium");
      return tags;
    }

    function xcScoreChair(product, filters) {
      var score = 40;
      var needs = product.needs || [];
      if (product.budget === filters.budget) score += 28;
      if (filters.budget === "under2000" && product.budget === "2000to3000") score -= 10;
      if (filters.budget === "under2000" && product.budget === "over3000") score -= 24;
      if (filters.budget === "2000to3000" && product.budget === "over3000") score -= 8;
      filters.needs.forEach(function(need) {
        if (needs.indexOf(need) > -1) {
          score += need === "massage" || need === "footrest" ? 30 : 12;
        } else if (need === "massage" || need === "footrest") {
          score -= 18;
        }
      });
      filters.otherTags.forEach(function(tag) {
        if (needs.indexOf(tag) > -1) score += 10;
      });
      return score;
    }

    function xcRenderChairFinder(root, triggeredByButton, nextIndex) {
      var budgetInput = root.querySelector("[data-xc-budget]:checked");
      var otherInput = root.querySelector("[data-xc-other-needs]");
      var results = root.querySelector("[data-xc-results]");
      var status = root.querySelector("[data-xc-fit-status]");
      if (!budgetInput || !results) return;
      var products = xcReadChairProducts(root);
      var filters = {
        budget: budgetInput.value,
        needs: xcSelectedNeeds(root),
        otherTags: xcOtherNeedTags(otherInput ? otherInput.value : "")
      };
      var ranked = products.slice().map(function(product) {
        return {
          product: product,
          score: Math.max(58, Math.min(98, xcScoreChair(product, filters)))
        };
      }).sort(function(a, b) {
        return b.score - a.score;
      }).slice(0, 3);
      root.xcCurrentResults = ranked;
      root.xcCurrentIndex = typeof nextIndex === "number" ? nextIndex % ranked.length : 0;
      var selected = ranked[root.xcCurrentIndex];
      var product = selected.product;
      var pills = (product.pills || []).slice(0, 3).map(function(pill) {
          return "<span>" + xcEscapeHtml(pill) + "</span>";
      }).join("");
      results.innerHTML = '<a class="xc-finder-card" href="' + xcEscapeHtml(product.url) + '">' +
        '<img src="' + xcEscapeHtml(product.image) + '" alt="' + xcEscapeHtml(product.title) + '" loading="lazy" width="640" height="520">' +
        '<div><div class="xc-finder-card__top"><small>' + xcEscapeHtml(product.badge) + '</small><span class="xc-finder-card__match">匹配度 ' + selected.score + '%</span></div><strong>' + xcEscapeHtml(product.title) + '</strong><p>' + xcEscapeHtml(product.body) + '</p><p class="xc-finder-card__pills">' + pills + '</p><em>' + xcEscapeHtml(product.price) + '</em></div>' +
      '</a>';
      if (status) {
        status.textContent = triggeredByButton ? "已重新推薦" : "已根據目前條件推薦";
      }
    }

    document.querySelectorAll("[data-xc-chair-finder]").forEach(function(root) {
      var button = root.querySelector("[data-xc-ai-recommend]");
      var nextButton = root.querySelector("[data-xc-next]");
      root.addEventListener("change", function() {
        xcRenderChairFinder(root, false, 0);
      });
      root.addEventListener("input", function(event) {
        if (event.target && event.target.matches("[data-xc-other-needs]")) {
          xcRenderChairFinder(root, false, 0);
        }
      });
      if (button) {
        button.addEventListener("click", function() {
          xcRenderChairFinder(root, true, 0);
        });
      }
      if (nextButton) {
        nextButton.addEventListener("click", function() {
          var nextIndex = ((root.xcCurrentIndex || 0) + 1) % ((root.xcCurrentResults || []).length || 1);
          xcRenderChairFinder(root, true, nextIndex);
        });
      }
      xcRenderChairFinder(root, false, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-home-office-preview"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var xcFallbackProducts = [
      {
        title: "M57C",
        badge: "Budget Pick",
        body: "預算控制在 2000 以下，又想要透氣坐感時，M57C 是更直接的選擇。",
        budget: "under2000",
        needs: ["breathable", "compact"],
        pills: ["全網透氣", "聯動扶手", "家用友好"],
        price: "查看目前價格",
        url: "/products/m57c",
        image: "https://hk.sihooxchair.com/cdn/shop/files/M57C_black_clean.png?v=1775558402"
      },
      {
        title: "C300二代 PRO",
        badge: "Recommended",
        body: "想要一張主力辦公椅，先看腰背跟隨、座深調節和扶手配置更均衡的 C300二代 PRO。",
        budget: "2000to3000",
        needs: ["lumbar", "office"],
        pills: ["久坐護腰", "座深可調", "5年保固"],
        price: "查看目前價格",
        url: "/products/c300-pro",
        image: "https://sihoooffice.com/cdn/shop/files/1940-1200.webp?v=1705046338&width=760"
      },
      {
        title: "C300二代 PRO 尊享版",
        badge: "Footrest",
        body: "工作、追劇和短休都想兼顧時，腳踏版本更完整，也更適合作為主力座位。",
        budget: "2000to3000",
        needs: ["footrest", "lumbar"],
        pills: ["腳踏短休", "久坐護腰", "5年保固"],
        price: "查看目前價格",
        url: "/products/c300-pro",
        image: "https://cdn.shopify.com/s/files/1/0632/8192/2264/files/1_0642161f-8f30-4702-bb6f-a434f8d70400.webp?v=1776389401"
      },
      {
        title: "C500二代",
        badge: "Flagship",
        body: "重視外觀、坐感和主動護腰支撐時，C500二代會比入門款更一步到位。",
        budget: "over3000",
        needs: ["lumbar", "premium"],
        pills: ["旗艦護腰", "主動支撐", "5年保固"],
        price: "查看目前價格",
        url: "/products/c500",
        image: "https://cdn.shopify.com/s/files/1/0702/0268/7541/files/C500up-black.png?v=1775788645"
      },
      {
        title: "T6",
        badge: "Massage",
        body: "如果按摩是剛需，T6 是更接近放鬆需求的方向，預算也會更高。",
        budget: "over3000",
        needs: ["massage", "premium"],
        pills: ["智能按摩", "高階放鬆", "客服確認"],
        price: "查看目前價格",
        url: "/products/t6",
        image: "https://hk.sihooxchair.com/cdn/shop/files/SKU_02_C500i_AI.jpg?v=1775535370"
      }
    ];

    function xcEscapeHtml(value) {
      return String(value || "").replace(/[&<>"']/g, function(character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      });
    }

    function xcReadChairProducts(root) {
      var script = root.querySelector("[data-xc-products-json]");
      var products = [];
      if (script) {
        try {
          products = JSON.parse(script.textContent || "[]").filter(function(product) {
            return product && product.title && product.image;
          });
        } catch (error) {
          products = [];
        }
      }
      xcFallbackProducts.forEach(function(fallback) {
        var exists = products.some(function(product) {
          return product.url === fallback.url || product.title === fallback.title;
        });
        if (!exists) products.push(fallback);
      });
      return products;
    }

    function xcSelectedNeeds(root) {
      return Array.prototype.slice.call(root.querySelectorAll("[data-xc-need]:checked")).map(function(input) {
        return input.value;
      });
    }

    function xcOtherNeedTags(value) {
      var text = String(value || "").toLowerCase();
      var tags = [];
      if (/腳|foot|休|躺/.test(text)) tags.push("footrest");
      if (/按摩|massage|放鬆/.test(text)) tags.push("massage");
      if (/腰|護腰|lumbar|久坐/.test(text)) tags.push("lumbar");
      if (/熱|透氣|網|breath/.test(text)) tags.push("breathable");
      if (/小|窄|細|compact|空間/.test(text)) tags.push("compact");
      if (/高階|旗艦|質感|premium/.test(text)) tags.push("premium");
      return tags;
    }

    function xcScoreChair(product, filters) {
      var score = 40;
      var needs = product.needs || [];
      if (product.budget === filters.budget) score += 28;
      if (filters.budget === "under2000" && product.budget === "2000to3000") score -= 10;
      if (filters.budget === "under2000" && product.budget === "over3000") score -= 24;
      if (filters.budget === "2000to3000" && product.budget === "over3000") score -= 8;
      filters.needs.forEach(function(need) {
        if (needs.indexOf(need) > -1) {
          score += need === "massage" || need === "footrest" ? 30 : 12;
        } else if (need === "massage" || need === "footrest") {
          score -= 18;
        }
      });
      filters.otherTags.forEach(function(tag) {
        if (needs.indexOf(tag) > -1) score += 10;
      });
      return score;
    }

    function xcRenderChairFinder(root, triggeredByButton) {
      var budgetInput = root.querySelector("[data-xc-budget]:checked");
      var otherInput = root.querySelector("[data-xc-other-needs]");
      var results = root.querySelector("[data-xc-results]");
      var status = root.querySelector("[data-xc-fit-status]");
      if (!budgetInput || !results) return;
      var products = xcReadChairProducts(root);
      var filters = {
        budget: budgetInput.value,
        needs: xcSelectedNeeds(root),
        otherTags: xcOtherNeedTags(otherInput ? otherInput.value : "")
      };
      var ranked = products.slice().sort(function(a, b) {
        return xcScoreChair(b, filters) - xcScoreChair(a, filters);
      }).slice(0, 3);
      results.innerHTML = ranked.map(function(product) {
        var pills = (product.pills || []).slice(0, 3).map(function(pill) {
          return "<span>" + xcEscapeHtml(pill) + "</span>";
        }).join("");
        return '<a class="xc-finder-card" href="' + xcEscapeHtml(product.url) + '">' +
          '<img src="' + xcEscapeHtml(product.image) + '" alt="' + xcEscapeHtml(product.title) + '" loading="lazy" width="640" height="520">' +
          "<div><small>" + xcEscapeHtml(product.badge) + "</small><strong>" + xcEscapeHtml(product.title) + "</strong><p>" + xcEscapeHtml(product.body) + "</p><p class=\"xc-finder-card__pills\">" + pills + "</p><em>" + xcEscapeHtml(product.price) + "</em></div>" +
        "</a>";
      }).join("");
      if (status) {
        status.textContent = triggeredByButton ? "已重新推薦" : "已根據目前條件推薦";
      }
    }

    document.querySelectorAll("[data-xc-chair-finder]").forEach(function(root) {
      var button = root.querySelector("[data-xc-ai-recommend]");
      root.addEventListener("change", function() {
        xcRenderChairFinder(root, false);
      });
      root.addEventListener("input", function(event) {
        if (event.target && event.target.matches("[data-xc-other-needs]")) {
          xcRenderChairFinder(root, false);
        }
      });
      if (button) {
        button.addEventListener("click", function() {
          xcRenderChairFinder(root, true);
        });
      }
      xcRenderChairFinder(root, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-product-office-preview"] && !Shopify.designMode) return;
  try {
    
  function xcOfficeOpenReview(sectionId) {
    var modal = document.querySelector('[data-xc-office-review-modal="' + sectionId + '"]');
    if (modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var successMessage = document.querySelector('[data-xc-office-review-success]');
    if (successMessage) {
      var successModal = successMessage.closest('[data-xc-office-review-modal]');
      var successSectionId = successModal && successModal.getAttribute('data-xc-office-review-modal');
      if (successSectionId) {
        xcOfficeOpenReview(successSectionId);
      }
    }

    document.querySelectorAll('.xc-office-pdp').forEach(function(root) {
      var fallback = root.getAttribute('data-xc-fallback-image');
      if (!fallback) return;

      root.querySelectorAll('img').forEach(function(image) {
        image.addEventListener('error', function() {
          if (image.getAttribute('data-xc-fallback-applied') === 'true') return;
          image.setAttribute('data-xc-fallback-applied', 'true');
          image.removeAttribute('srcset');
          image.setAttribute('src', fallback);
        }, { once: true });
      });
    });
  });

  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('[data-xc-office-review-open]');
    if (openButton) {
      xcOfficeOpenReview(openButton.getAttribute('data-xc-office-review-open'));
    }

    var closeButton = event.target.closest('[data-xc-office-review-close]');
    if (closeButton) {
      var modal = document.querySelector('[data-xc-office-review-modal="' + closeButton.getAttribute('data-xc-office-review-close') + '"]');
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    }

    if (event.target.classList && event.target.classList.contains('xc-office-modal')) {
      event.target.classList.remove('is-open');
      event.target.setAttribute('aria-hidden', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-product-premium-content"] && !Shopify.designMode) return;
  try {
    
  function xcOpenReviewModal(sectionId) {
    var modal = document.querySelector('[data-xc-review-modal="' + sectionId + '"]');
    if (modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var successMessage = document.querySelector('[data-xc-review-success]');
    if (successMessage) {
      var successModal = successMessage.closest('[data-xc-review-modal]');
      var successSectionId = successModal && successModal.getAttribute('data-xc-review-modal');
      if (successSectionId) {
        xcOpenReviewModal(successSectionId);
      }
    }
  });

  document.addEventListener('click', function(event) {
    var fitTab = event.target.closest('[data-xc-fit-tab]');
    if (fitTab) {
      var fitSection = fitTab.closest('[data-xc-fit]');
      var fitKey = fitTab.getAttribute('data-xc-fit-tab');
      if (fitSection && fitKey) {
        fitSection.querySelectorAll('[data-xc-fit-tab]').forEach(function(tab) {
          var isActive = tab === fitTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        fitSection.querySelectorAll('[data-xc-fit-panel]').forEach(function(panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-xc-fit-panel') === fitKey);
        });
      }
    }

    var openButton = event.target.closest('[data-xc-review-open]');
    if (openButton) {
      var sectionId = openButton.getAttribute('data-xc-review-open');
      xcOpenReviewModal(sectionId);
    }

    var closeButton = event.target.closest('[data-xc-review-close]');
    if (closeButton) {
      var closeId = closeButton.getAttribute('data-xc-review-close');
      var closeModal = document.querySelector('[data-xc-review-modal="' + closeId + '"]');
      if (closeModal) {
        closeModal.classList.remove('is-open');
        closeModal.setAttribute('aria-hidden', 'true');
      }
    }

    var modalBackdrop = event.target.classList && event.target.classList.contains('xc-premium-review-modal');
    if (modalBackdrop) {
      event.target.classList.remove('is-open');
      event.target.setAttribute('aria-hidden', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xc-tm-series-live-product"]) return;
  try {
    
  document.querySelectorAll('[data-xc-tm-product]').forEach((root) => {
    if (root.dataset.xcTmReady === 'true') return;
    root.dataset.xcTmReady = 'true';
    const variantData = root.querySelector('[data-xc-tm-variant-data]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const optionGroups = Array.from(root.querySelectorAll('[data-option-position]'));
    const form = root.querySelector('[data-xc-tm-form]');
    const variantInput = root.querySelector('[data-xc-tm-variant-id]');
    const priceNode = root.querySelector('[data-xc-tm-price]');
    const compareNode = root.querySelector('[data-xc-tm-compare]');
    const savingNode = root.querySelector('[data-xc-tm-saving]');
    const priceBlock = root.querySelector('[data-xc-tm-price-block]');
    const offerState = root.querySelector('[data-xc-tm-offer-state]');
    const offerLabel = root.querySelector('[data-xc-tm-offer-label]');
    const toast = root.querySelector('[data-xc-tm-toast]');
    const primaryBuy = root.querySelector('[data-xc-tm-buy]');
    const whatsapp = root.querySelector('[data-xc-tm-whatsapp]');
    const mobileBar = root.querySelector('[data-xc-tm-mobile-buy]');
    const mobileSubmit = root.querySelector('[data-xc-tm-mobile-submit]');
    const mobileWhatsapp = root.querySelector('[data-xc-tm-mobile-whatsapp]');
    const stickyPrice = root.querySelector('[data-xc-tm-sticky-price]');
    const stickySelection = root.querySelector('[data-xc-tm-sticky-selection]');
    const drawer = root.querySelector('[data-xc-tm-drawer]');
    const drawerOptions = root.querySelector('[data-xc-tm-drawer-options]');
    const drawerPrice = root.querySelector('[data-xc-tm-drawer-price]');
    const drawerSelection = root.querySelector('[data-xc-tm-drawer-selection]');
    const drawerBuy = root.querySelector('[data-xc-tm-drawer-buy]');
    const error = root.querySelector('[data-xc-tm-error]');
    const seasonalOffer = root.dataset.seasonalOffer === 'true';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeVariant = null;
    let hasUserSelected = false;
    let offerStarted = false;
    let drawerInvoker = null;
    let activeGalleryIndex = 0;

    const numberPrice = (variant) => Number(String(variant?.price || '').replace(/[^0-9.]/g, ''));
    const prefixOf = (variant) => String(variant?.price || 'HK$').match(/^[^0-9]*/)?.[0] || 'HK$';
    const formatAmount = (variant, amount) => `${prefixOf(variant)}${Number(amount).toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const discountedAmount = (variant) => numberPrice(variant) * 0.95;
    const displayedPrice = (variant, finalPrice = offerStarted) => seasonalOffer && finalPrice ? formatAmount(variant, discountedAmount(variant)) : variant?.price || '';
    const lowestVariant = () => variants.filter((variant) => variant.available !== false).sort((a, b) => numberPrice(a) - numberPrice(b))[0] || variants[0] || null;
    const selectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    const completeSelection = () => hasUserSelected && optionGroups.length > 0 && optionGroups.every((group) => Boolean(group.querySelector('input:checked')?.value));
    const selectedLabel = () => {
      const values = selectedOptions().filter(Boolean);
      return values.length ? `已選：${values.join(' / ')}` : '未選擇規格';
    };
    const matchingVariant = () => {
      const options = selectedOptions();
      const exact = variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      if (exact) return exact;
      return variants.filter((variant) => variant.options.every((value, index) => !options[index] || value === options[index])).sort((a, b) => numberPrice(a) - numberPrice(b))[0] || activeVariant || lowestVariant();
    };
    const savingAmount = (variant) => {
      if (!variant?.compareAt) return 0;
      const compare = seasonalOffer ? numberPrice(variant.compareAt) : Number(String(variant.compareAt).replace(/[^0-9.]/g, ''));
      const sale = seasonalOffer ? discountedAmount(variant) : numberPrice(variant);
      return Math.max(0, compare - sale);
    };
    const syncOptionAvailability = () => {
      const options = selectedOptions();
      optionGroups.forEach((group) => {
        const position = Number(group.dataset.optionPosition) - 1;
        group.querySelectorAll('[data-xc-tm-option]').forEach((input) => {
          const available = variants.some((variant) => variant.available !== false && variant.options[position] === input.value && variant.options.every((value, index) => index === position || !options[index] || value === options[index]));
          input.disabled = !available;
          input.nextElementSibling?.classList.toggle('is-unavailable', !available);
        });
      });
    };
    const syncContactLinks = (variant) => {
      if (!variant) return;
      const title = root.dataset.productTitle || '';
      const configuration = variant.title || selectedOptions().filter(Boolean).join(' / ');
      const baseLine = `目前頁面售價：${variant.price}`;
      const offerLine = seasonalOffer ? `秋季特惠到手價：約 ${formatAmount(variant, discountedAmount(variant))}` : '';
      const question = seasonalOffer ? '請問這個配置的最終優惠及送貨安排？' : '請問這個配置的送貨、保固及安裝安排？';
      const message = [`你好，我想了解 ${title}。`, '', `目前選擇：${configuration}`, baseLine, offerLine, '', question].filter(Boolean).join('\n');
      const href = `https://wa.me/8613005471130?text=${encodeURIComponent(message)}`;
      [whatsapp, mobileWhatsapp].forEach((link) => { if (link) link.href = href; });
    };
    const syncPrice = (variant, finalPrice = offerStarted) => {
      if (!variant) return;
      if (priceNode) priceNode.textContent = `${displayedPrice(variant, finalPrice)}${completeSelection() ? '' : ' 起'}`;
      if (compareNode) compareNode.textContent = variant.compareAt || '';
      if (savingNode) {
        const amount = savingAmount(variant);
        savingNode.textContent = amount ? `已節省 ${formatAmount(variant, amount)}` : '';
        if (!seasonalOffer) savingNode.style.visibility = amount ? '' : 'hidden';
      }
      if (offerLabel) offerLabel.textContent = finalPrice ? '秋季特惠到手價' : '日常售價';
    };
    const syncPurchaseUI = () => {
      const ready = completeSelection();
      const variant = activeVariant || lowestVariant();
      if (!variant) return;
      const price = displayedPrice(variant);
      if (stickyPrice) stickyPrice.textContent = `${price}${ready ? '' : ' 起'}`;
      if (stickySelection) stickySelection.textContent = ready ? selectedLabel() : (hasUserSelected ? '請完成選擇' : '未選擇規格');
      if (drawerPrice) drawerPrice.textContent = price;
      if (drawerSelection) drawerSelection.textContent = ready ? selectedLabel() : (hasUserSelected ? '請完成選擇' : '請選擇你的配置');
      if (drawerBuy) drawerBuy.disabled = !ready || variant.available === false;
      if (mobileSubmit) mobileSubmit.disabled = variant.available === false;
      syncContactLinks(variant);
    };
    const updateImage = (index) => {
      const thumbs = Array.from(root.querySelectorAll('[data-xc-tm-thumb]'));
      const mainImage = root.querySelector('[data-xc-tm-stage] > img');
      if (!thumbs.length || !mainImage) return;
      activeGalleryIndex = Math.max(0, Math.min(index, thumbs.length - 1));
      const thumb = thumbs[activeGalleryIndex];
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.srcset = thumb.dataset.imageSrcset || '';
      mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
      thumbs.forEach((item, itemIndex) => { item.classList.toggle('is-active', itemIndex === activeGalleryIndex); item.setAttribute('aria-current', String(itemIndex === activeGalleryIndex)); });
      const counter = root.querySelector('[data-xc-tm-counter]');
      if (counter) counter.textContent = `${activeGalleryIndex + 1} / ${thumbs.length}`;
      const previous = root.querySelector('[data-xc-tm-previous]');
      const next = root.querySelector('[data-xc-tm-next]');
      if (previous) previous.disabled = activeGalleryIndex === 0;
      if (next) next.disabled = activeGalleryIndex === thumbs.length - 1;
    };
    const renderDrawer = () => {
      if (!drawerOptions) return;
      drawerOptions.replaceChildren();
      optionGroups.forEach((group) => {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'xc-tm-product__drawer-group';
        const legend = document.createElement('legend');
        legend.textContent = group.querySelector('legend')?.textContent?.trim() || '規格';
        const list = document.createElement('div');
        list.className = 'xc-tm-product__drawer-choice-list';
        group.querySelectorAll('[data-xc-tm-option]').forEach((input) => {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'xc-tm-product__drawer-choice';
          choice.textContent = input.value;
          choice.disabled = input.disabled;
          choice.classList.toggle('is-selected', hasUserSelected && input.checked);
          choice.addEventListener('click', () => { hasUserSelected = true; input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); });
          list.appendChild(choice);
        });
        fieldset.append(legend, list);
        drawerOptions.appendChild(fieldset);
      });
    };
    const openDrawer = () => { if (!window.matchMedia('(max-width:749px)').matches) { const firstIncomplete = optionGroups.find((group) => !group.querySelector('input:checked')); firstIncomplete?.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' }); firstIncomplete?.querySelector('input')?.focus({ preventScroll: true }); return; } if (!drawer) return; drawerInvoker = document.activeElement; renderDrawer(); syncPurchaseUI(); drawer.hidden = false; document.documentElement.classList.add('xc-tm-drawer-open'); drawer.querySelector('[data-xc-tm-close]')?.focus({ preventScroll: true }); };
    const closeDrawer = () => { if (!drawer) return; drawer.hidden = true; document.documentElement.classList.remove('xc-tm-drawer-open'); drawerInvoker?.focus({ preventScroll: true }); drawerInvoker = null; };
    const checkout = async (variant, buttonPosition) => {
      if (!variant || variant.available === false || !form) return;
      const sourceButton = buttonPosition === 'mobile_sticky_drawer' ? drawerBuy : buttonPosition === 'mobile_sticky' ? mobileSubmit : primaryBuy;
      if (typeof window.xcTrackCheckoutStart === 'function') window.xcTrackCheckoutStart({
        product_handle: root.dataset.productHandle || '',
        product_title: root.dataset.productTitle || document.title,
        variant_id: String(variant.id || ''),
        variant_title: variant.title || '',
        price: displayedPrice(variant),
        button_position: buttonPosition || 'pdp_primary',
        page_path: window.location.pathname
      }, sourceButton);
      if (error) error.hidden = true;
      if (primaryBuy) primaryBuy.disabled = true;
      if (mobileSubmit) mobileSubmit.disabled = true;
      if (drawerBuy) { drawerBuy.disabled = true; drawerBuy.textContent = '正在前往結賬…'; }
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const data = new FormData(form);
        data.set('id', String(variant.id));
        data.set('quantity', '1');
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        if (!response.ok) throw new Error('add_failed');
        window.location.assign(`${rootPath}checkout`);
      } catch (requestError) {
        if (error) error.hidden = false;
        if (primaryBuy) primaryBuy.disabled = false;
        if (drawerBuy) { drawerBuy.disabled = false; drawerBuy.textContent = '立即購買'; }
        syncPurchaseUI();
      }
    };
    const startOfferAnimation = () => {
      if (!seasonalOffer || offerStarted || !activeVariant || !priceNode) return;
      offerStarted = true;
      if (toast) { toast.hidden = false; toast.classList.remove('is-visible'); void toast.offsetWidth; toast.classList.add('is-visible'); window.setTimeout(() => { toast.classList.remove('is-visible'); toast.hidden = true; }, 3000); }
      if (prefersReducedMotion) { syncPrice(activeVariant, true); syncPurchaseUI(); return; }
      const start = numberPrice(activeVariant);
      const end = discountedAmount(activeVariant);
      const startedAt = performance.now();
      const tick = (now) => { const progress = Math.min(1, (now - startedAt) / 3000); const eased = 1 - Math.pow(1 - progress, 3); priceNode.textContent = formatAmount(activeVariant, start + (end - start) * eased); if (progress < 1) window.requestAnimationFrame(tick); else { syncPrice(activeVariant, true); syncPurchaseUI(); } };
      window.requestAnimationFrame(tick);
    };
    const scheduleOffer = () => {
      if (!seasonalOffer || !priceBlock) return;
      if (!window.matchMedia('(max-width:749px)').matches) { window.setTimeout(startOfferAnimation, 180); return; }
      const onScroll = () => { if (window.scrollY < 96) return; const rect = priceBlock.getBoundingClientRect(); if (rect.bottom <= 0 || rect.top >= window.innerHeight) return; window.removeEventListener('scroll', onScroll); startOfferAnimation(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    };
    const updateVariant = (changedInput = null) => {
      if (changedInput) hasUserSelected = true;
      activeVariant = matchingVariant();
      if (!activeVariant) return;
      if (variantInput) variantInput.value = activeVariant.id;
      syncOptionAvailability();
      syncPrice(activeVariant);
      syncPurchaseUI();
      renderDrawer();
      if (activeVariant.imageUrl) {
        const mainImage = root.querySelector('[data-xc-tm-stage] > img');
        if (mainImage) { mainImage.src = activeVariant.imageUrl; mainImage.srcset = activeVariant.imageSrcset || ''; }
      }
      if (completeSelection()) { const url = new URL(window.location.href); url.searchParams.set('variant', activeVariant.id); window.history.replaceState({}, '', url); }
    };
    root.querySelectorAll('[data-xc-tm-option]').forEach((input) => input.addEventListener('change', () => updateVariant(input)));
    root.querySelectorAll('[data-xc-tm-thumb]').forEach((thumb, index) => thumb.addEventListener('click', () => updateImage(index)));
    root.querySelector('[data-xc-tm-previous]')?.addEventListener('click', () => updateImage(activeGalleryIndex - 1));
    root.querySelector('[data-xc-tm-next]')?.addEventListener('click', () => updateImage(activeGalleryIndex + 1));
    root.querySelectorAll('[data-xc-tm-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });
    primaryBuy?.addEventListener('click', () => { if (completeSelection()) checkout(activeVariant, 'pdp_primary'); else openDrawer(); });
    mobileSubmit?.addEventListener('click', () => { if (completeSelection()) checkout(activeVariant, 'mobile_sticky'); else openDrawer(); });
    drawerBuy?.addEventListener('click', () => { if (completeSelection()) checkout(activeVariant, 'mobile_sticky_drawer'); });
    let stickyScrollIntent = false;
    let stickyRevealArmed = false;
    const syncStickyVisibility = () => { if (!mobileBar) return; const primaryRect = primaryBuy?.getBoundingClientRect(); const primaryVisible = primaryRect && primaryRect.bottom > 0 && primaryRect.top < window.innerHeight; const shouldShow = window.matchMedia('(max-width:749px)').matches && stickyRevealArmed && stickyScrollIntent && window.scrollY > 96 && !primaryVisible; mobileBar.classList.toggle('is-visible', shouldShow); mobileBar.setAttribute('aria-hidden', String(!shouldShow)); };
    window.addEventListener('scroll', () => { stickyScrollIntent = true; syncStickyVisibility(); }, { passive: true });
    window.addEventListener('resize', syncStickyVisibility);
    window.setTimeout(() => { stickyRevealArmed = true; syncStickyVisibility(); }, 700);
    root.querySelector('[data-xc-tm-back-top]')?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' }));
    const backTop = root.querySelector('[data-xc-tm-back-top]');
    window.addEventListener('scroll', () => backTop?.classList.toggle('is-visible', window.scrollY > 700), { passive: true });
    const linkedVariantId = new URL(window.location.href).searchParams.get('variant');
    const linkedVariant = variants.find((variant) => String(variant.id) === String(linkedVariantId) && variant.available !== false);
    activeVariant = linkedVariant || lowestVariant();
    if (activeVariant) {
      optionGroups.forEach((group) => {
        const position = Number(group.dataset.optionPosition) - 1;
        group.querySelectorAll('[data-xc-tm-option]').forEach((input) => {
          input.checked = input.value === activeVariant.options[position];
        });
      });
      hasUserSelected = optionGroups.length > 0
        ? optionGroups.every((group) => Boolean(group.querySelector('input:checked')?.value))
        : true;
      if (variantInput) variantInput.value = activeVariant.id;
    }
    syncOptionAvailability();
    syncPrice(activeVariant, false);
    syncPurchaseUI();
    renderDrawer();
    updateImage(0);
    scheduleOffer();
  });

  } catch(e) { console.error(e); }
})();
})();
